import Vue from "vue";
import Router from "vue-router";
import About from "./views/About.vue";
import Colors from "./views/Colors.vue";
import Content from "./views/content";
import ContentDelete from "./views/content/delete.vue";
import ContentEdit from "./views/content/edit.vue";
import Pattern from "./views/pattern";
import PatternCreate from "./views/pattern/create.vue";
import Navigation from "./views/navigation";
import Stock from "./views/stock";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: Content
    },
    {
      path: "/about",
      name: "about",
      component: About
    },
    {
      path: "/colors",
      name: "colors",
      component: Colors
    },
    {
      path: "/content",
      name: "content",
      component: Content
    },
    {
      path: "/content/create",
      name: "content-create",
      component: ContentEdit
    },
    {
      path: "/content/:id",
      name: "content-edit",
      component: ContentEdit,
      props: true
    },
    {
      path: "/content/:id/delete",
      name: "content-delete",
      component: ContentDelete,
      props: true
    },
    {
      path: "/navigation",
      name: "navigation",
      component: Navigation
    },
    {
      path: "/stock-basket",
      name: "stock-basket",
      component: Stock
    },
    {
      path: "/stock-patterns",
      name: "stock-patterns",
      component: Pattern
    },
    {
      path: "/stock-pattern/create",
      name: "stock-pattern-create",
      component: PatternCreate
    }
  ]
});
